import { render } from "./AppFooter.vue?vue&type=template&id=4b73be8e"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=4b73be8e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rlb-poc.prepare.servicedesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__